import {EnumModel} from '../models/enum.model';

export class DatumiHelper {


  static racunajdatum(jednokratno: boolean, mesec: number): string  {

    let godina = new Date().getFullYear();
    const dan = new Date().getDate();


    let calMesec = new Date().getMonth() + 1;

    if (calMesec === 12 && dan > 20) {
      godina = godina + 1;
    }

    let datum: string;

    if (mesec < 10) {
      datum = godina + '-0' + mesec + '-01';
    } else {
      datum = godina + '-' + mesec + '-01';
    }

    return datum;
  }

  static racunajgodinu(jednokratno: boolean): number  {

    let godina = new Date().getFullYear();
    const mesec = new Date().getMonth() + 1;
    const dan = new Date().getDate();

    if (mesec === 12 && dan > 20) {
      godina = godina + 1;
    }

    return godina;
  }


  static listameseci(jednokratno: boolean): EnumModel[] {

    const dan = new Date().getDate();
    const mesec = new Date().getMonth() + 1;
    const listameseci: EnumModel[] = new Array();

    if (mesec === 12 && dan < 17) {

      listameseci[0] = new EnumModel(12, String(12));

    } else if (mesec === 12 && dan > 20){



        for (let i = 1; i <= 12; i++) {
          listameseci.push(new EnumModel(i, String(i)));
        }



    }
    else {

      for (let i = mesec; i <= 12; i++) {
        listameseci.push(new EnumModel(i, String(i)));
      }

    }

    return listameseci;
  }










}



// WEBPACK FOOTER //
// ./src/app/helpers/datum.helper.ts